import React from 'react'
import styled, { css } from 'styled-components'

const BadgeSpan = styled.span<{
  $backgroundColor?: string,
  $fontSize?: string,
}>(
  ({
    theme: {
      typography,
      palette,
    },
    $backgroundColor,
    $fontSize,
  }) => css`
    background-color: ${$backgroundColor || palette.product.marketing.main};
    color: ${palette.light.white} !important;
    padding: 2px 6px;
    text-align: center;
    border-radius: 5px;
    font-size: ${$fontSize || typography.small.pt_13_medium.fontSize};
    font-weight: ${typography.small.pt_13_medium.fontWeight};
    line-height: ${typography.small.pt_13_medium.lineHeight};
  `,
)

export const Badge = ({
  label,
  backgroundColor,
  fontSize,
}: { label: string,
  backgroundColor: string,
  fontSize?: string
}): JSX.Element => (
  <BadgeSpan
    $backgroundColor={backgroundColor}
    $fontSize={fontSize}
  >
    {label}
  </BadgeSpan>
)

Badge.defaultProps = {
  fontSize: undefined,
}
